// @ts-nocheck

/** @type {NodeListOf<HTMLElement>} */ document
    .querySelectorAll("[data-filter-container]")
    .forEach((filterList) => {
        const searchInput =
            /** @type {HTMLInputElement | null} */ filterList.querySelector(
                "[data-filter-search]",
            );
        const moreButton =
            /** @type {HTMLButtonElement | null} */ filterList.querySelector(
                "[data-btn-more]",
            );
        const lessButton =
            /** @type {HTMLButtonElement | null} */ filterList.querySelector(
                "[data-btn-less]",
            );
        const items = /** @type {HTMLElement[]} */ [
            ...filterList.querySelectorAll("[data-filter-item]"),
        ];
        const placeholder = filterList.querySelector(
            "[data-filter-placeholder]",
        );

        if (!searchInput || !moreButton || !lessButton || !placeholder) {
            throw new Error("Failed to find an element for filtered list");
        }

        // Раскрытие списка
        moreButton.addEventListener("click", () => {
            filterList.dataset.expanded = "true";
            toggleButtons();
        });

        // Сворачивание списка
        lessButton.addEventListener("click", () => {
            filterList.dataset.expanded = "false";

            items.forEach((item) => {
                item.classList.remove("display-none");
            });
            searchInput.value = "";
            showPlaceholder(false);
            toggleButtons();
        });

        // Поиск и фильтрация элементов списка
        searchInput.addEventListener("input", (e) => {
            const searchString = /** @type {HTMLInputElement} */ e.target.value
                .toLowerCase()
                .trim();
            items.forEach((item) => {
                const isItemVisible = item.dataset.title
                    ?.toLowerCase()
                    .trim()
                    .includes(searchString);

                if (isItemVisible) {
                    item.classList.remove("display-none");
                } else {
                    item.classList.add("display-none");
                }
            });

            const hasVisibleItems = items.some(
                (item) => window.getComputedStyle(item).display !== "none",
            );
            showPlaceholder(!hasVisibleItems);
        });

        // Показать или скрыть сообщение о том, что искомые элементы в списке не найдены
        /** @param {boolean} show */
        const showPlaceholder = (show) => {
            if (show) {
                placeholder.classList.remove("display-none");
            } else {
                placeholder.classList.add("display-none");
            }
        };

        const toggleButtons = () => {
            moreButton.classList.toggle("display-none");
            lessButton.classList.toggle("display-none");
        };
    });
